import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { CustomerInfoDialogComponent } from './customer-info-dialog.component';

import { CustomerInfoData } from './customer-info.data';

@Injectable()
export class CustomerInfoDialogService {
  constructor(private dialog: MatDialog) {}

  open(customerInfo?: CustomerInfoData) {
    return this.dialog
      .open(CustomerInfoDialogComponent, {
        data: customerInfo,
        disableClose: true,
        maxWidth: '600px',
        width: '95vw',
      })
      .afterClosed();
  }
}
